export default __webpack_public_path__ + "static/media/GRWorldpay-logo.b501964a.png";